export const appealRagBands = [
    { key: "success", minReceivedDaysAgo: 0, maxReceivedDaysAgo: 9 },
    { key: "warning", minReceivedDaysAgo: 10, maxReceivedDaysAgo: 19 },
    { key: "danger", minReceivedDaysAgo: 20, maxReceivedDaysAgo: null },
]

export const appealRagBandLabels = Object.fromEntries(appealRagBands.map(band => [
    band.key,
    band.maxReceivedDaysAgo === null ? `${band.minReceivedDaysAgo}+ days ago` : `${band.minReceivedDaysAgo}-${band.maxReceivedDaysAgo} days ago`
]))

export const getAppealRagStatus = (numberOfDaysAgo) => {
    if (numberOfDaysAgo === null || numberOfDaysAgo === undefined) return null
    return appealRagBands.find(band => numberOfDaysAgo >= band.minReceivedDaysAgo && (band.maxReceivedDaysAgo === null || numberOfDaysAgo <= band.maxReceivedDaysAgo))?.key ?? "success"
}
